import * as React from 'react';

function SvgNoPayment(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#000"
          fillRule="nonzero"
          d="M.91 4.1l1.47 1.46c-.2.26-.34.59-.37.95v.17L2 9h3.82l2 2H2v6.47c0 .8.58 1.44 1.32 1.52l.15.01h12.35l2 2H3.3C1.55 21 .11 19.53 0 17.68V6.53c0-.94.35-1.8.91-2.44zM20.7 3c1.75 0 3.19 1.47 3.3 3.32v11.15c0 .94-.35 1.8-.91 2.44l-1.44-1.45c.19-.23.31-.52.34-.83l.01-.16V11h-7.82l-2-2H22V6.68c0-.87-.58-1.59-1.32-1.67L20.53 5H8.18l-2-2H20.7zm-1.64 12c.52 0 .94.45.94 1 0 .23-.07.45-.2.62L18.18 15h.88z"
        />
        <path
          stroke="#FF5D52"
          strokeLinecap="round"
          strokeWidth={2}
          d="M1.5 1.5l21 21"
        />
      </g>
    </svg>
  );
}

export default SvgNoPayment;
